//@ts-check
var loadAccordingToCacheStrategy = function loadAccordingToCacheStrategy(options, loadData) {
  var cacheStrategy = options.cacheStrategy;
  var needsFetch = false;

  if (cacheStrategy === 'cache-only') {
    needsFetch = false;
  } else if (cacheStrategy === 'cache-first') {
    //TODO: check if the item is in the store and don't fetch if it's there
    needsFetch = true;
  } else if (cacheStrategy === 'stale-while-revalidate') {
    needsFetch = true;
  }

  if (needsFetch) return loadData();
  return false;
};

export default loadAccordingToCacheStrategy;